import { render, staticRenderFns } from "./SyncDeviceMontaj.vue?vue&type=template&id=590b4321"
import script from "./SyncDeviceMontaj.vue?vue&type=script&lang=js"
export * from "./SyncDeviceMontaj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports